export interface Sort {
  readonly sorted: boolean;
  readonly empty: boolean;
  readonly unsorted: boolean;
}

export interface Pageable {
  readonly pageNumber: number;
  readonly pageSize: number;
}

export interface Page<T> {
  readonly content: readonly T[];
  readonly last: boolean;
  readonly first: boolean;
  readonly size: number;
  readonly totalElements: number;
  readonly totalPages: number;
  readonly sort: Sort;
  readonly numberOfElements: number;
  readonly empty: boolean;
  readonly pageable: Pageable;
}

export class Page<T> {
  readonly content: readonly T[] = [];

  public static empty<T>(): Page<T> {
    return {
      content: [],
      last: false,
      first: false,
      size: 0,
      totalElements: 0,
      totalPages: 0,
      sort: {
        sorted: false,
        empty: false,
        unsorted: false,
      },
      numberOfElements: 0,
      empty: false,
      pageable: {
        pageSize: 0,
        pageNumber: 0,
      },
    };
  }
}
